var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inactive-input",style:({background: ("rgba(" + (_vm.FlowHelper.typeSocketColor(_vm.SocketNames.Inactive)) + ", 0.15)")})},[_c('time-unit-input',{staticClass:"w-full mt-0 mb-0",attrs:{"setup":{
      'func': _vm.inactiveInputChange,
      'args': {
        'model': this,
        'key': 'time',
        'prefix': 'flow_inactive_action_',
        'max': 604800,
        'units': [_vm.StepUnit.Second, _vm.StepUnit.Minute, _vm.StepUnit.Hour, _vm.StepUnit.Day],
        'inline': true
      },
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }